import { render, staticRenderFns } from "./CreateClient.vue?vue&type=template&id=8f3ae624&scoped=true&"
import script from "./CreateClient.vue?vue&type=script&lang=js&"
export * from "./CreateClient.vue?vue&type=script&lang=js&"
import style0 from "./CreateClient.vue?vue&type=style&index=0&id=8f3ae624&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f3ae624",
  null
  
)

export default component.exports